import { b2MassData } from "./shapes.js";
import { b2Vec2 } from "./common/math.js";
import { b2Scalar } from "./common/precision.js";
import { b2Settings } from "./common/settings.js";

export class b2TimeStep {
  constructor() {
    this.warmStarting = false;
    this.positionCorrection = false;
    this.dt = 0;
    this.maxIterations = 0;
    this.dtRatio = 0;
    this.inv_dt = 0;
    this.velocityIterations = 0;
    this.positionIterations = 0;
  }

  Set(step) {
    this.dt = b2Scalar(step.dt);
    this.inv_dt = b2Scalar(step.inv_dt);
    this.positionIterations = step.positionIterations;
    this.velocityIterations = step.velocityIterations;
    this.maxIterations = step.maxIterations ?? step.velocityIterations ?? step.positionIterations ?? 0;
    this.warmStarting = step.warmStarting;
    this.positionCorrection = step.positionCorrection;
    this.dtRatio = b2Scalar(step.dtRatio ?? 0);
  }
}

export class b2ContactFilter {
  static b2_defaultFilter = null;

  ShouldCollide(shape1, shape2) {
    const filter1 = shape1.GetFilterData();
    const filter2 = shape2.GetFilterData();
    if (filter1.groupIndex === filter2.groupIndex && filter1.groupIndex !== 0) {
      return filter1.groupIndex > 0;
    }
    return (filter1.maskBits & filter2.categoryBits) !== 0 && (filter1.categoryBits & filter2.maskBits) !== 0;
  }
}

b2ContactFilter.b2_defaultFilter = new b2ContactFilter();

export class b2ContactImpulse {
  constructor() {
    this.normalImpulses = new Array(b2Settings.b2_maxManifoldPoints).fill(0);
    this.tangentImpulses = new Array(b2Settings.b2_maxManifoldPoints).fill(0);
  }
}

export class b2BodyDef {
  constructor() {
    this.angularDamping = 0;
    this.angle = 0;
    this.isSleeping = false;
    this.awake = true;
    this.position = new b2Vec2();
    this.isBullet = false;
    this.allowSleep = true;
    this.userData = null;
    this.fixedRotation = false;
    this.linearDamping = 0;
    this.type = 0;
    this.massData = new b2MassData();
    this.massData.center.SetZero();
    this.massData.mass = 0;
    this.massData.I = 0;
    this.position.Set(0, 0);
  }
}
